var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_188",
    x: 0,
    y: 0,
    width: 33,
    height: 33,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selected_icon",
    "data-name": "Selected icon",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -1.5)",
    filter: "url(#Ellipse_188)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188-2",
    "data-name": "Ellipse 188",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1.5 1.5)",
    fill: "#56aa1c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10385",
    "data-name": "Path 10385",
    d: "M450.93,477.83l-2.125,2.125-2.125-2.125-4.251-4.251,2.125-2.125L448.8,475.7l8.5-8.5,2.125,2.125Z",
    transform: "translate(-435.932 -458.579)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedicon);
export default __webpack_public_path__ + "static/media/Selected icon.9eecd6c5f07c9c0a271ae611753b0d9e.svg";
export { ForwardRef as ReactComponent };